/* eslint-disable prettier/prettier */
import Circle from './circle.svg'
import HalfCircle from './half-circle.svg'
import LineCircle from './line-circle.svg'
import LineWaves from './line-waves.svg'
import Pie from './pie.svg'
import Rhombus from './rhombus.svg'

export default {
  'circle': Circle,
  'half-circle': HalfCircle,
  'line-circle': LineCircle,
  'line-waves': LineWaves,
  'pie': Pie,
  'rhombus': Rhombus,
}